export default __webpack_public_path__ + "static/media/TodoList.7e7a4d6d.gif";